import type { LiveMatchEvent } from '@/models/liveMatch';

function isShootoutEvent(event: LiveMatchEvent): boolean {
  if (event.type !== 'goal') return false;
  if (event.detail === 'Missed Penalty') return true;
  return event.minute >= 120;
}

export function isDisplayableMatchEvent(event: LiveMatchEvent): boolean {
  if (event.type === 'goal') return !isShootoutEvent(event);
  if (event.type === 'card') return event.detail.includes('Red');
  return false;
}

export function filterDisplayableEvents(events: LiveMatchEvent[]): LiveMatchEvent[] {
  return events.filter(isDisplayableMatchEvent);
}
